import React from 'react'
import { useTimeTableMonth } from '../../state/storeTimeTable'
import { useConditional } from '../../state/storeConditional ';


const CalenderTypeHijra = () => {
    const {updateIsOnChangeInHijra} = useConditional()

    const {HijraLocale,updateHijraLocale } = useTimeTableMonth();

    return (
        <fieldset className='m-2'>
            <legend>Select a Calendar Type Hijra:</legend>

            <div className='m-2'>
                <input className='m-2' type="radio" id="islamic-umalqura" name="calender" value="islamic-umalqura" onChange={() => {
                    updateHijraLocale({...HijraLocale,calenderType:"islamic-umalqura"})
                    updateIsOnChangeInHijra(true)
                    }}  defaultChecked={HijraLocale.calenderType === "islamic-umalqura"}  />
                <label htmlFor="islamic-umalqura">islamic-umalqura</label>
            </div>

            <div className='m-2'>
                <input className='m-2' type="radio" id="islamic-civil" name="calender" value="islamic-civil" onChange={() => {
                updateHijraLocale({...HijraLocale,calenderType:"islamic-civil"})
                updateIsOnChangeInHijra(true)
                }} defaultChecked={HijraLocale.calenderType === "islamic-civil"}  />
                <label htmlFor="islamic-civil">islamic-civil</label>
            </div>

        </fieldset>
    )
}

export default CalenderTypeHijra